var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1081,
    height: 896,
    viewBox: "0 0 1081 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M499.534 246.256C333.943 210.827 122.732 -3.75906 -58.8369 170.324V841.25H1159.16V119.809C1159.16 119.809 1079.6 36.1939 928.574 3.2019C777.546 -29.7901 665.124 281.684 499.534 246.256Z",
    fill: "#D9E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.684 472.982C768.314 451.742 982.858 331.457 1166.66 435.819V954.25H-66.3369V481.339C-66.3369 481.339 53.8679 350.278 167.092 335.631C280.315 320.983 433.054 494.221 600.684 472.982Z",
    fill: "#9CBDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.833 606.207C148.637 525.74 68.6707 544.514 -85.8369 734.249L-66.3369 985.249H1166.66V606.207C1166.66 606.207 1030.66 656.249 845.663 591.749C660.663 527.249 529.03 686.674 338.833 606.207Z",
    fill: "#528BE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.163 667.267C818.36 602.179 1012.16 482.647 1166.66 636.117V1004.27H-66.3369V793.267C-66.3369 793.267 -31.1228 647.747 155.663 636.117C342.449 624.488 437.966 732.354 628.163 667.267Z",
    fill: "#326AC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.b384d956692c766921b1f3fe122eb6b7.svg";
export { ForwardRef as ReactComponent };